/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Jobs_Card_Location_LabelInputs */

const en_company_jobs_card_location_label = /** @type {(inputs: Company_Jobs_Card_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location:`)
};

const de_company_jobs_card_location_label = /** @type {(inputs: Company_Jobs_Card_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort:`)
};

/**
* | output |
* | --- |
* | "Location:" |
*
* @param {Company_Jobs_Card_Location_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_jobs_card_location_label = /** @type {((inputs?: Company_Jobs_Card_Location_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Jobs_Card_Location_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_jobs_card_location_label(inputs)
	return en_company_jobs_card_location_label(inputs)
});